import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';

const getUrl = ({ host, eventsAndNewsId }: { host: string; eventsAndNewsId: string }) => {
  return `${host}/events-news/${eventsAndNewsId}`;
};

export const RemoveEventsAndNews = async ({
  token,
  host,
  eventsAndNewsId,
}: {
  token: string;
  host: string;
  eventsAndNewsId: string;
}): Promise<void> => {
  try {
    const url = getUrl({ host, eventsAndNewsId });

    const options: AxiosRequestConfig = {
      url,
      method: 'DELETE',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    (await axios(options)) as AxiosResponse<void>;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
